import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'bp-icon-chat-bubble',
	templateUrl: './icon-chat-bubble.component.svg',
})
export class IconChatBubbleComponent {}
